<template>
  <q-layout view="hHh LpR lFf" class="bg-white">
    <layout-toolbar />
    <layout-drawer />
    <notification-drawer />
    <q-page-container :key="currentBranch.ID">
      <transition name="component-fade" mode="out-in">
        <router-view />
      </transition>
    </q-page-container>
    <!--layout-footer
      v-if="
        $store.getters['auth/alSupport'] &&
        !$store.getters['auth/isEmployee']
      "
    /-->
    <a-welcome-modal />
    <notifications-dialog
      v-if="openNotificationsDialog"
      :open="openNotificationsDialog"
      :notification="notifications[0]"
    />
  </q-layout>
</template>

<script>
import LayoutToolbar from './layout-components/Toolbar';
import LayoutDrawer from './layout-components/drawer/DrawerWrapper';
import NotificationDrawer from './layout-components/drawer/NotificationDrawer';
import AWelcomeModal from '@/components/dashboard/onboarding/Onboarding';
import NotificationsDialog from '@/components/base/NotificationsDialog';

import { mapGetters, mapState } from 'vuex';

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Default',
  components: {
    LayoutToolbar,
    LayoutDrawer,
    AWelcomeModal,
    NotificationsDialog,
    NotificationDrawer,
  },
  data() {
    return {
      miniState: false,
      leftDrawerOpen: true,
      miniWidth: 60,
      width: 200,
    };
  },
  computed: {
    ...mapState('auth', ['currentBranch']),
    ...mapState('connection', ['desync']),
    ...mapGetters('auth', [
      'alSupport',
      'isTrialPeriodActive',
    ]),
    ...mapGetters('subscription', [
      'notSubscriptedToMainPackage',
    ]),
    ...mapState('notifications', ['notifications']),
    openNotificationsDialog() {
      if (this.notifications.length === 0) return false;
      if (this.notifications.some(n => n.showPopUp === 1)) return true;

      return false;
    },
    forwardToPaymentPage() {
      if (this.alSupport) return false;
      if (this.isTrialPeriodActive) return false;
      return this.notSubscriptedToMainPackage;
    },
  },
  watch: {
    forwardToPaymentPage: {
      immediate: true,
      handler(forwardToPaymentPage) {
        if (forwardToPaymentPage) this.$router.replace('/payment');
      },
    },
    desync: {
      immediate: true,
      async handler(desync) {
        if (!desync) return;

        await new Promise(resolve => setTimeout(resolve, 1000));

        this.$q.notify({
          message: 'Eine neue Version wurde veröffentlicht!',
          detail: 'Bitte laden Sie die Seite neu.',
          type: 'info',
          position: 'bottom-right',
          timeout: 0,
          actions: [
            {
              icon: 'refresh',
              handler: () => {
                window.location.reload();
              },
            },
          ],
        });
      },
    },
  },
  created() {
    this.$store.dispatch('userSetting/getAllSettings');
    this.$store.dispatch('auth/reloadCurrentBranch');
    this.$store.dispatch('notifications/getAllNotifications');
  },
};
</script>

<style scoped lang="stylus">
.component-fade-enter-active, .component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter, .component-fade-leave-to {
  opacity: 0;
}
</style>
